"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = remove;
const core_1 = require("@aws-amplify/core");
const remove_1 = require("./internal/remove");
function remove(input) {
    if ('key' in input) {
        return (0, remove_1.remove)(core_1.Amplify, input);
    }
    else {
        return (0, remove_1.remove)(core_1.Amplify, input);
    }
}
